import { SET } from "../";
import { CampaignsService, Webshop, WebshopCore } from "@/services";
import { WebshopCampaign, WebshopProduct } from "@/services/models";
import moment from "moment";
import { cloneDeep } from 'lodash'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    filter: {
      hasParentCampaign: null,
      campaignPromotionTypes: [],
      statuses: [2],
      dateFrom: null,
      dateTo: null,
      subscribedSalons: [],
      CampaignPlatforms: [5],
    },
    campaigns: [],
    campaignsByLevel: null,
    campaign: null,
    bundle: null,
    bundles: [],
  },
  getters: {
    get: (state) => (key) => state[key],
    getCampaign: (state) => state.campaign,
    getCampaignById: (state) => (id) => state.campaigns[id],
  },
  mutations: {
    SET,
    PUSH_BUNDLE:(state, bundle) => {
      if(!state.bundles.find(c => c.campaignId === bundle.campaignId)){
        state.bundles.push(bundle)
      } else {
        var index = state.bundles.findIndex(c => c.campaignId === bundle.campaignId)
        Vue.set(state.bundles, index, bundle)
      }
    }
  },
  actions: {
    set({ commit }, payload) {
      commit("SET", payload);
    },
    async getCampaingsByFilter({ commit, state, rootState }, chainId) {
      let filter = state.filter;
      let response = await CampaignsService.GetCampaingsByFilter(
        filter,
        chainId
      );

      let campaigns = response.data.result.sort((a, b) =>
        moment(b.UpdatedTime).diff(a.UpdatedTime)
      );
      campaigns = campaigns.map((c) => new WebshopCampaign(c));
      /**
       * Filter only good campaigns to promote
       * GOOD CAMPAIGN - imageUrl != 0, isActive and !bundle
       */
      if (campaigns.length) {
        var sorted = campaigns.sort(
          (a, b) =>
            moment(b.dateOfPromotion).format("YYYYMMDDHHmmss") -
            moment(a.dateOfPromotion).format("YYYYMMDDHHmmss")
        ).filter(
          (c) =>
            c.promotionType.promotionTypeName != "Bundle" && c.imageUrl > 0
        );
        var campaignsByLevel;
        if (sorted.length) {
          var topLevel = sorted.filter((c) => c.promotionLevel == 2).length
            ? sorted.filter((c) => c.promotionLevel == 2)
            : [sorted[0]];
          var topLevelIds = topLevel.map((c) => c.campaignId);
          var filtered1 = sorted.filter(
            (c) => !topLevelIds.includes(c.campaignId)
          );
          var midLevel = filtered1.filter((c) => c.promotionLevel == 1).length
            ? filtered1.filter((c) => c.promotionLevel == 1)
            : filtered1.length > 2
              ? filtered1.slice(0, 2)
              : filtered1;
          var midLevelIds = midLevel.map((c) => c.campaignId);
          var filtered2 = filtered1.filter(
            (c) => !midLevelIds.includes(c.campaignId)
          );
          var lowLevel = filtered2.filter((c) => c.promotionLevel == 0).length
            ? filtered2.filter((c) => c.promotionLevel == 0)
            : filtered2;
        }

        campaignsByLevel = {
          topLevel,
          midLevel,
          lowLevel,
        };



        var activeSites = cloneDeep(rootState.webshop.settings?.activatedSalons).map(s => s.siteId) || []
        var deliverySites = cloneDeep(rootState.webshop.settings?.activatedSalons).filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
        var campaignBundles = campaigns.filter(c => c.promotionType.promotionTypeName === 'Bundle');
        campaignBundles.forEach(async bundle => {
          var b = cloneDeep(bundle)
          let productsResponse = await Webshop.GetProductsByIds({
            chainId: chainId,
            productIds: b.productIds
          });

          let products = productsResponse.data.ProductList.map(product => new WebshopProduct(product));

          products.forEach(prod => {
            var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
            var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
            prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
            prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
          })
          var subs = b.subscriptionList.filter(s => activeSites.includes(s.siteId))

          subs.forEach(s => {
            var stocks = []
            products.forEach(p => {
              var productStock = p.productDetails.inventory.filter(s => activeSites.includes(s.siteId)).find(x => x.siteId == s.siteId)?.stockAmount ?? 0
              stocks.push(productStock)
            })
            if (s.availableAmount == 0 || s.availableAmount > Math.min(...stocks)) {
              s.availableAmount = Math.min(...stocks)
            } else if (Math.min(...stocks) > b.maxPerCustomer) {
              s.availableAmount = b.maxPerCustomer
            }
          })
          b.products = products
          b.subscriptionList = subs
          // Object.assign(b, {products: products})
          // Object.assign(b, {subscriptionList: subs})

          var onlineStocks = b.subscriptionList.filter(x => activeSites.includes(x.siteId))?.map(x => x.availableAmount)
          var shipmentStock = b.subscriptionList.filter(x => deliverySites.includes(x.siteId))?.map(x => x.availableAmount)
          b.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
          b.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0

          commit("PUSH_BUNDLE", b)
        });

        commit("SET", { key: "campaigns", value: campaigns });
        commit("SET", { key: "campaignsByLevel", value: campaignsByLevel });
      }

    },
    async fetchById({ state, commit, dispatch, rootState, getters }, args) {
      if (!args.campaignId) console.warn("No CampaignId provided");
      if (!args.chainId) console.warn("No ChainId provided");
      let campaign = getters.getCampaignById(args);
      if (campaign != null) {
        return cloneDeep(state.campaigns[args.campaignId]);
      } else {
        let response = await CampaignsService.GetCampaign(args);
        Object.assign(args.fetchProducts, {
          productIds: response.data.result.productIds,
        });
        Object.assign(args.fetchProducts, {
          campaignProducts: response.data.result.products,
        });
        var params = args.fetchProducts;
        let responseProds = await Webshop.GetCampaignProducts(params);
        let products = responseProds.data.ProductList.map(
          (product) => new WebshopProduct(product)
        );
        var activeSites = rootState.webshop.settings?.activatedSalons.map(s => s.siteId) || []
        var deliverySites = rootState.webshop.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
        products.forEach((prod) => {

          
          
          let campaignPrice = params.campaignProducts.find(
            (p) => p.productId === prod.id
          ).salePrice;

          let quantity = params.campaignProducts.find(
            (p) => p.productId === prod.id
          ).amount;
          prod.quantity = quantity
          prod.campaignPrice = campaignPrice;
          prod.campaignDiscount =
            prod.productDetails.price != campaignPrice
              ? Math.round(
                ((prod.productDetails.price - campaignPrice) /
                  prod.productDetails.price) *
                100
              )
              : null;
          var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
          var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
          prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
          prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
        });
        response.data.result.products = null;
        campaign = new WebshopCampaign(response.data.result);
        campaign.products = products;
        /**
         * Add the additional product (Y product) if we're dealing with a Buy X Get Y campaign.
         */
        if (campaign.benefitRule == 3) {
          let additionalProductId = params.campaignProducts.find(x => x.isAdditionalProduct).productId

          campaign.additionalProduct = products.find(x => x.id == additionalProductId)
          campaign.additionalProduct.isAdditionalProduct = true
          campaign.products = products.filter(x => x.id != additionalProductId)
        }
        dispatch("webshop/setProductData", responseProds.data, { root: true });


        // campaign.products.forEach((prod) => {
        //   prod.campaigns = response.data.Campaign.Products.find(
        //     (p) => p.Id === prod.id
        //   ).Campaigns;
        // });
      }
      if (campaign.promotionType.promotionTypeName === 'Bundle') {
        campaign.products.forEach(prod => {
          var onlineStocks = prod.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
          var shipmentStock = prod.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
          prod.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
          prod.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0
        })
        var lowestPriceRes = await WebshopCore.GetLowestBundlePrice(campaign.campaignId)

        var subs = campaign.subscriptionList.filter(s => activeSites.includes(s.siteId))

        subs.forEach(s => {
          var stocks = []
          campaign.products.forEach(p => {
            var productStock = p.productDetails.inventory.find(x => x.siteId == s.siteId)?.stockAmount ?? 0
            stocks.push(productStock)
          })
          if (s.availableAmount == 0 || s.availableAmount > Math.min(...stocks)) {
            s.availableAmount = Math.min(...stocks)
          } else if (Math.min(...stocks) > campaign.maxPerCustomer) {
            s.availableAmount = campaign.maxPerCustomer
          }
        })
        Object.assign(campaign, { subscriptionList: subs })

        var onlineStocks = campaign.subscriptionList.filter(x => activeSites.includes(x.siteId))?.map(x => x.availableAmount)
        var shipmentStock = campaign.subscriptionList.filter(x => deliverySites.includes(x.siteId))?.map(x => x.availableAmount)
        Object.assign(campaign, { onlineStock: onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0 })
        Object.assign(campaign, { stockForDelivery: shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0 })
        if (lowestPriceRes.data.responseCode === 200 && lowestPriceRes.data.dto && lowestPriceRes.data.dto?.bundleCampaignId && lowestPriceRes.data.dto?.price && lowestPriceRes.data.dto?.lastDate) {
          Object.assign(campaign , { lowestPrice: lowestPriceRes.data.dto?.bundleCampaignId === campaign.campaignId ? lowestPriceRes.data.dto?.price : 0 })
          Object.assign(campaign , { dateOFLowestPrice: lowestPriceRes.data.dto?.bundleCampaignId === campaign.campaignId ? lowestPriceRes.data.dto?.lastDate : null})
        }
      }
      commit('SET', {
        key: "campaign",
        value: campaign
      })
      return campaign

    },
  },
};
